var _rect, _path, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluewhiteClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1982_21033)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1982_21033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1982_21033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1216 16.5L22.6607 11.9609C22.8761 11.7459 22.9973 11.4541 22.9976 11.1497C22.9978 10.8453 22.8772 10.5533 22.6621 10.3379C22.4471 10.1225 22.1553 10.0013 21.8509 10.001C21.5465 10.0007 21.2545 10.1214 21.0391 10.3364L16.5 14.8755L11.9609 10.3364C11.7455 10.121 11.4534 10 11.1487 10C10.844 10 10.5519 10.121 10.3364 10.3364C10.121 10.5519 10 10.844 10 11.1487C10 11.4534 10.121 11.7455 10.3364 11.9609L14.8755 16.5L10.3364 21.0391C10.121 21.2545 10 21.5466 10 21.8513C10 22.156 10.121 22.4481 10.3364 22.6636C10.5519 22.879 10.844 23 11.1487 23C11.4534 23 11.7455 22.879 11.9609 22.6636L16.5 18.1245L21.0391 22.6636C21.2545 22.879 21.5466 23 21.8513 23C22.156 23 22.4481 22.879 22.6636 22.6636C22.879 22.4481 23 22.156 23 21.8513C23 21.5466 22.879 21.2545 22.6636 21.0391L18.1216 16.5Z",
    fill: "#5B55FF"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 30.6667,
    height: 30.6667,
    rx: 3.33333,
    stroke: "#5B55FF",
    strokeWidth: 1.33333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1982_21033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluewhiteClose);
export default __webpack_public_path__ + "static/media/bluewhite_close.4db50accd75b879072ea96a23d01e53e.svg";
export { ForwardRef as ReactComponent };